import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommonUtil } from '../../../../core/Utils/common-util';
import { HaloToastService, EToastType } from '../../../../core/halo-toast/halo-toast.service';
import { HaloLoaderService } from '../../../../core/halo-loader/halo-loader.service';
import {
  MultiFacilityModel,
  SelectWithCheckboxRadioOption,
  SelectWithCheckboxRadioValue,
} from '../../../../post-login/services/multi-facility.model';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-set-level',
  templateUrl: './set-level.component.html',
  styleUrls: ['./set-level.component.scss'],
})
export class SetLevelComponent implements OnInit {
  option = { selectedFacType: 'independent' };
  @Input() facDetails: MultiFacilityModel;
  @Input() facilities: MultiFacilityModel[];
  @Input() isMobile: boolean;
  @Input() isRTL: boolean;
  @Output() closeClick = new EventEmitter();
  title: string;
  currentLevel: String;
  _allowedLevel: String;

  possibleSubsidiaryFacilities: SelectWithCheckboxRadioOption[] = [];
  selectedSubsidiaryFacilities: SelectWithCheckboxRadioValue;
  isDisabled = "true";

  constructor(
    private _router: Router,
    private _commonUtil: CommonUtil,
    private _service: MultiFacilityService,
    private _toast: HaloToastService,
    private _loader: HaloLoaderService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {}

  ngOnInit(): void {
    if (!this.isMobile) {
      this.title = this._commonUtil.replaceValueAsHTMLOnTranslatedText('SET.LEVEL.FOR', [this.facDetails.facilityName]);
    } else {
      this.title = this._commonUtil.translateText('SET.LEVEL');
    }

    if (this.facDetails.level === '1') {
      this.option.selectedFacType = 'parent';
    }
    this._allowedLevel = this._service.allowedLevel.toString();
    this.buildDropdown();
    this.refreshIsDisabled();
  }

  closeModal(): void {
    this.closeClick.emit(false);
  }

  setLevel(): void {
    switch (this.option.selectedFacType) {
      case 'independent':
        this._setLevelIndependent();
        break;
      case 'parent':
        this._setLevelParent();
        break;
      default:
        break;
    }
    this.refreshIsDisabled();
  }

  changeFacilityType(){
    this.refreshIsDisabled();
  }

  private _setLevelIndependent() {
    this._loader.startProcess();    
    this._amplitudeAnalytics.logEvent({elementName: 'Set Level Independent', action: 'Submit'});
    this._service.setIndependent(this.facDetails).then(
      (res: boolean) => {
        if (res) {
          // success
          this._toast.creatToast(
            this._commonUtil.replaceValueAsHTMLOnTranslatedText('INDEPENDENT.SUCCESS.MSG', [
              this.facDetails.facilityName,
            ]),
            EToastType.SUCCESS
          );
        } else {
          // fail
        }
        this._loader.endProcess();
      },
      (err: any) => {
        this.handleRESTError(err);
        this._loader.endProcess();
      }
    );
  }

  private _setLevelParent() {
    this._loader.startProcess();
    this._amplitudeAnalytics.logEvent({elementName: 'Set Level Parent', action: 'Submit'});
    this._service.setParent(this.facDetails, this.selectedSubsidiaryFacilities).then(
      (res: boolean) => {
        this._loader.endProcess();
        this._toast.creatToast(
          this._commonUtil.replaceValueAsHTMLOnTranslatedText('PARENT.SUCCESS.MSG', [
            this.facDetails.facilityName,
            this.facDetails.facilityName
          ]),
          EToastType.SUCCESS
        );
        this.closeClick.emit(true);
      },
      (err: any) => {
        this.handleRESTError(err);
        this._loader.endProcess();
      }
    );
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

  buildDropdown() {
    this.possibleSubsidiaryFacilities = this._service.getParents(this.facDetails);
  }

  loop(facilities: MultiFacilityModel[], currentFacilityId: string) {}

  onSelectSubsidiaryFacilities(data: SelectWithCheckboxRadioValue) {
    this.selectedSubsidiaryFacilities = data;
    this.refreshIsDisabled();
  }
  handleRESTError(err: any) {
    const zendeskUrl = 'https://halofitness.zendesk.com/hc/en-us/articles/360058547072';
    let htmlToAdd: any = '<a style="color:#22b8cb" href=' + zendeskUrl + '>' + zendeskUrl + '</a>';
    const errorMessage = this._commonUtil.replaceValueAsHTMLOnTranslatedText('SET.LEVEL.ERROR.TOAST', [htmlToAdd]);
    this._toast.creatToast(errorMessage, EToastType.ERROR, 5000);
  }

  refreshIsDisabled() {
    this.isDisabled = this.option.selectedFacType === "independent"?
    "false":
    (this.selectedSubsidiaryFacilities === undefined ? "true" : this.selectedSubsidiaryFacilities.selected && this.selectedSubsidiaryFacilities.selected.length === 0  ? 'true' : 'false');
  }
}
